<div class="goods-shop-list-container" data-testid="goods-shop-list-page">
  <!-- Header Section -->
  <div class="header-section">
    <div class="header-content">
      <h1 class="page-title">Product Store Management</h1>
      <p class="page-description">
        Manage product listings and delistings in stores
      </p>
    </div>
    <div class="header-actions">
      @if (canCreate()) {
        <p-button
          data-testid="goods-shop-list-add-btn"
          label="Add Product to Store"
          icon="add"
          severity="success"
          (onClick)="navigateToForm('add')"
        ></p-button>
      }
    </div>
  </div>

  <!-- Search and Filter Section -->
  <div class="search-filter-section">
    <div class="search-container">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input
          data-testid="goods-shop-list-search-input"
          pInputText
          type="text"
          placeholder="Search by SPU Code, SPU ID, or Shop ID..."
          [value]="searchTerm()"
          (input)="onSearchChange($event)"
          class="search-input"
        />
      </span>
    </div>

    <div class="filter-container">
      <select
        data-testid="goods-shop-list-status-filter"
        class="status-filter"
        (change)="onStatusFilterChange($event)"
        [value]="statusFilter() || ''"
      >
        <option value="">All Status</option>
        <option *ngFor="let option of statusOptions()" [value]="option.value">
          {{ option.label }}
        </option>
      </select>

      <p-button
        data-testid="goods-shop-list-clear-filters-btn"
        label="Clear Filters"
        icon="pi pi-times"
        severity="secondary"
        text
        (onClick)="clearFilters()"
        [disabled]="!searchTerm() && statusFilter() === null"
      ></p-button>
    </div>
  </div>

  <!-- Table Section -->
  <div class="table-section">
    <p-table
      data-testid="goods-shop-list-table"
      [value]="filteredList()"
      [loading]="loading()"
      [paginator]="false"
      [rows]="pageSize()"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[10, 25, 50]"
      responsiveLayout="scroll"
      styleClass="p-datatable-sm"
    >
      <!-- SPU ID Column -->
      <ng-template pTemplate="header">
        <tr>
          <th>SPU ID</th>
          <th>SPU Code</th>
          <th>Shop ID</th>
          <th>Status</th>
          <th>Created Date</th>
          <th>Created By</th>
          <th>Actions</th>
        </tr>
      </ng-template>

      <!-- Data Rows -->
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.spuId }}</td>
          <td>{{ item.spuCode }}</td>
          <td>{{ item.shopId }}</td>
          <td>
            <span
              class="status-badge"
              [class]="'status-' + getStatusSeverity(item.status)"
            >
              {{ getStatusLabel(item.status) }}
            </span>
          </td>
          <td>{{ item.creationDate | date: "dd/MM/yyyy HH:mm:ss" }}</td>
          <td>{{ item.createdBy || "-" }}</td>
          <td>
            <div class="action-buttons">
              @if (canUpdate()) {
                <app-button
                  [testId]="'goods-shop-list-action-edit'"
                  class="action-edit"
                  label="Edit"
                  type="action"
                  (emitOnClick)="navigateToForm('edit', item)"
                ></app-button>
              }
              @if (canDelete()) {
                <app-button
                  [testId]="'goods-shop-list-action-delete'"
                  class="action-delete"
                  label="Delete"
                  type="action"
                  (emitOnClick)="deleteGoodsShop(item)"
                ></app-button>
              }
            </div>
          </td>
        </tr>
      </ng-template>

      <!-- Empty State -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="empty-state">
            <div class="empty-content">
              <i class="pi pi-inbox empty-icon"></i>
              <p class="empty-text">No product store relationships found</p>
              @if (canCreate()) {
                <p-button
                  label="Add First Product"
                  icon="add"
                  severity="success"
                  (onClick)="navigateToForm('add')"
                ></p-button>
              }
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Pagination -->
  <div class="pagination-section" *ngIf="totalRecords() > 0">
    <p-paginator
      data-testid="goods-shop-list-paginator"
      [rows]="pageSize()"
      [totalRecords]="totalRecords()"
      [rowsPerPageOptions]="[10, 25, 50]"
      (onPageChange)="onPageChange($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    ></p-paginator>
  </div>
</div>

<!-- Toast Messages -->
<p-toast data-testid="goods-shop-list-toast"></p-toast>
